module.exports = __webpack_public_path__ + "img/20.18af54db.png";